export const tableColumns = [
  {
    text: "Beneficiarios",
  },
  {
    text: "DNI",
  },
  {
    text: "Porcentaje",
  },
  {
    text: "",
  },
];
